import { forwardRef, useCallback, useEffect, useState } from "react";
import Select from "react-select";
import { projectService } from "../services/project.service";
import { IProjectOption } from "Dashboard/domain/IProjectOption";

const ProjectSelect = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState<IProjectOption[]>([]);
  const { value, setValue } = props;
  const [valueLocal, setValueLocal] = useState<IProjectOption | null>(null);

  useEffect(() => {
    async function getData() {
      setIsLoading(true);
      const projects = await projectService.getProjectsForPayable(
        { showHiddenInDropDowns: props.showHiddenInDropDowns });
      const mappedProjects = projects.map((project) => ({
        label: project.name,
        value: project.projectId,
        active: project.active
      }));

      const filteredOptions = mappedProjects.filter(project => project.active);
      setOptions(filteredOptions);
      setIsLoading(false);
    }
    try {
      if (props.options) {
        setOptions(props.options.filter(
          (option: IProjectOption) => option.active));
      } else {
        getData();
      }
    } catch (err) {
      console.log(err);
    }
  }, [props.options, props.showHiddenInDropDowns]);

  const setValueFunction = useCallback((option: IProjectOption | null) => {
    if (setValue) {
      setValue(option);
    }
    setValueLocal(option);
  }, [setValue]);

  useEffect(() => {
    if (props.defaultValue) {
      const values = options.filter((o) => o.value === props.defaultValue);
      if (values[0]) {
        setValueFunction(values[0]);
      } else {
        setValueFunction(null);
      }
    }
  }, [props.defaultValue, options, setValueFunction]);

  const getValue = () => {
    if (value) {
      const values = options.filter((o) => o.value === value);
      if (values[0]) {
        return values[0];
      }
    }
    return valueLocal;
  };

  const handleChange = (newValue: IProjectOption | null, actionMeta: any) => {
    setValueFunction(newValue);
    props.onChange && props.onChange(newValue ? newValue.value : null);
  };

  return (
    <Select
      styles={props.customStyles}
      menuPosition="fixed"
      closeMenuOnScroll={(e) => {
        const target = e.target;
        if (!target || !(target instanceof HTMLElement)) return false;
        return target === props.scrollContainerRef?.current;
      }}
      isClearable={props.isClearable !== undefined ? props.isClearable : true}
      ref={ref}
      options={options}
      value={getValue()}
      onChange={handleChange}
      menuPortalTarget={props.menuPortalTarget ? props.menuPortalTarget : null}
      placeholder={props.placeholder ? props.placeholder : ""}
      noOptionsMessage={() => "Ne postoji"}
      isLoading={isLoading}
      isDisabled={props.disabled === true}
      {...{ error: props.error, width: props.width, dropdownIndicator: false }}
    />
  );
});

export default ProjectSelect;
